"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactI18next = require("react-i18next");
var _classnames = _interopRequireDefault(require("classnames"));
var _ramda = require("ramda");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Collapsed = require("../../../../../ui/Collapsed");
var _Button = _interopRequireWildcard(require("../../../../../ui/Button"));
var _helpers = require("../../helpers");
var _useFiltersData2 = require("../../useFiltersData");
var _styles = _interopRequireDefault(require("./styles"));
var _clearIcon = _interopRequireDefault(require("./clearIcon.svg"));
var _templateObject;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var FilterTitleWrapper = _styledComponents.default.span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  :hover {\n    .", ",\n    .", ",\n    .", " {\n      color: ", ";\n    }\n  }\n"])), _styles.default['filter-title'], _styles.default['filter-clear-btn'], _styles.default['filter-clear-btn__icon'], function (props) {
  return props.theme.primaryColor;
});
var renderCollapsedTriggerContent = function renderCollapsedTriggerContent(_ref) {
  var isFilterActive = _ref.isFilterActive,
    title = _ref.title,
    t = _ref.t;
  return isFilterActive ? /*#__PURE__*/_react.default.createElement(FilterTitleWrapper, {
    className: _styles.default['filter-title-wrapper']
  }, /*#__PURE__*/_react.default.createElement("h5", {
    className: _styles.default['filter-title']
  }, title), /*#__PURE__*/_react.default.createElement("span", {
    className: _styles.default['filter-clear-btn']
  }, t('RESET_FILTER_BUTTON'), /*#__PURE__*/_react.default.createElement("span", {
    className: _styles.default['filter-clear-btn__icon'],
    dangerouslySetInnerHTML: {
      __html: _clearIcon.default
    }
  }))) : title;
};
var Filters = function Filters(_ref2) {
  var countryID = _ref2.countryID,
    filters = _ref2.filters,
    offers = _ref2.offers,
    onChangeFilters = _ref2.onChangeFilters;
  var _useTranslation = (0, _reactI18next.useTranslation)('RESULT_CARD'),
    t = _useTranslation.t;
  var _useFiltersData = (0, _useFiltersData2.useFiltersData)({
      countryID: countryID,
      offers: offers
    }),
    hourRanges = _useFiltersData.hourRanges,
    operators = _useFiltersData.operators,
    rooms = _useFiltersData.rooms;
  var isHourRangeFilterEmpty = (0, _helpers.getIsHourRangeFilterEmpty)(filters.inbound) && (0, _helpers.getIsHourRangeFilterEmpty)(filters.outbound);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Collapsed.Collapsed, {
    arrow: (0, _helpers.getIsRoomFilterEmpty)(filters.rooms),
    contentClassName: _styles.default['filter-wrapper'],
    className: (0, _classnames.default)(_styles.default.filter, _styles.default['filter--without-border-bottom-radius']),
    title: renderCollapsedTriggerContent({
      isFilterActive: !(0, _helpers.getIsRoomFilterEmpty)(filters.rooms),
      title: t('FILTER_ROOM_TITLE'),
      t: t
    }),
    triggerBtnClassName: (0, _classnames.default)(_styles.default['filter-title__btn'], _styles.default['filter-title__btn--without-border-bottom-radius']),
    onClose: function onClose() {
      if (!(0, _helpers.getIsRoomFilterEmpty)(filters.rooms)) {
        onChangeFilters((0, _ramda.mergeAll)([filters, (0, _helpers.createFilter)('rooms', (0, _helpers.createFilters)().rooms)]));
      }
    }
  }, (0, _ramda.map)(function (room) {
    return /*#__PURE__*/_react.default.createElement(_Button.default, {
      key: room.id,
      size: _Button.SIZES.TINY,
      theme: (0, _helpers.getIsRoomFilterActive)(room.id, filters.rooms) ? _Button.THEMES.PURPLE : _Button.THEMES.GRAY,
      onClick: function onClick() {
        onChangeFilters((0, _ramda.mergeAll)([filters, (0, _helpers.createFilter)('rooms', (0, _helpers.toggleRoomFilterValue)(room.id, filters.rooms))]));
      }
    }, room.name);
  }, rooms)), /*#__PURE__*/_react.default.createElement(_Collapsed.Collapsed, {
    arrow: (0, _helpers.getIsOperatorFilterEmpty)(filters.operators),
    contentClassName: _styles.default['filter-wrapper'],
    className: (0, _classnames.default)(_styles.default.filter, _styles.default['filter--without-border-radius']),
    title: renderCollapsedTriggerContent({
      isFilterActive: !(0, _helpers.getIsOperatorFilterEmpty)(filters.operators),
      title: t('FILTER_OPERATOR_TITLE'),
      t: t
    }),
    triggerBtnClassName: (0, _classnames.default)(_styles.default['filter-title__btn'], _styles.default['filter-title__btn--without-border-radius']),
    onClose: function onClose() {
      if (!(0, _helpers.getIsOperatorFilterEmpty)(filters.operators)) {
        onChangeFilters((0, _ramda.mergeAll)([filters, (0, _helpers.createFilter)('operators', (0, _helpers.createFilters)().operators)]));
      }
    }
  }, (0, _ramda.map)(function (operator) {
    return /*#__PURE__*/_react.default.createElement(_Button.default, {
      key: operator.id,
      size: _Button.SIZES.TINY,
      theme: (0, _helpers.getIsOperatorFilterActive)(operator.id, filters.operators) ? _Button.THEMES.PURPLE : _Button.THEMES.GRAY,
      onClick: function onClick() {
        onChangeFilters((0, _ramda.mergeAll)([filters, (0, _helpers.createFilter)('operators', (0, _helpers.toggleOperatorFilterValue)(operator.id, filters.operators))]));
      }
    }, operator.name);
  }, operators)), /*#__PURE__*/_react.default.createElement(_Collapsed.Collapsed, {
    arrow: isHourRangeFilterEmpty,
    className: (0, _classnames.default)(_styles.default.filter, _styles.default['filter--without-border-top-radius']),
    title: renderCollapsedTriggerContent({
      isFilterActive: !isHourRangeFilterEmpty,
      title: t('FILTER_FLIGHT_START'),
      t: t
    }),
    triggerBtnClassName: (0, _classnames.default)(_styles.default['filter-title__btn'], _styles.default['filter-title__btn--without-border-top-radius']),
    onClose: function onClose() {
      if (!isHourRangeFilterEmpty) {
        onChangeFilters((0, _ramda.mergeAll)([filters, (0, _helpers.createFilter)('outbound', (0, _helpers.createFilters)().outbound), (0, _helpers.createFilter)('inbound', (0, _helpers.createFilters)().inbound)]));
      }
    }
  }, /*#__PURE__*/_react.default.createElement("h5", {
    className: _styles.default['filter-subTitle']
  }, t('FILTER_FLIGHT_DEPARTURE_TITLE')), (0, _ramda.map)(function (rangeOption) {
    return /*#__PURE__*/_react.default.createElement(_Button.default, {
      className: _styles.default['filter-hour-range-option'],
      key: rangeOption.key,
      size: _Button.SIZES.TINY,
      theme: (0, _helpers.getIsHourRangeFilterActive)(rangeOption.value, filters.outbound) ? _Button.THEMES.PURPLE : _Button.THEMES.GRAY,
      onClick: function onClick() {
        onChangeFilters((0, _ramda.mergeAll)([filters, (0, _helpers.createFilter)('outbound', (0, _helpers.toggleHourRangeFilterValue)(rangeOption.value, filters.outbound))]));
      }
    }, rangeOption.content);
  }, hourRanges), /*#__PURE__*/_react.default.createElement("h5", {
    className: (0, _classnames.default)(_styles.default['filter-subTitle'], _styles.default['filter-subTitle--top-offset'])
  }, t('FILTER_FLIGHT_ARRIAVAL_TITLE')), (0, _ramda.map)(function (rangeOption) {
    return /*#__PURE__*/_react.default.createElement(_Button.default, {
      className: _styles.default['filter-hour-range-option'],
      key: rangeOption.key,
      size: _Button.SIZES.TINY,
      theme: (0, _helpers.getIsHourRangeFilterActive)(rangeOption.value, filters.inbound) ? _Button.THEMES.PURPLE : _Button.THEMES.GRAY,
      onClick: function onClick() {
        onChangeFilters((0, _ramda.mergeAll)([filters, (0, _helpers.createFilter)('inbound', (0, _helpers.toggleHourRangeFilterValue)(rangeOption.value, filters.inbound))]));
      }
    }, rangeOption.content);
  }, hourRanges)));
};
Filters.propTypes = {
  countryID: _propTypes.default.number.isRequired,
  offers: _propTypes.default.arrayOf(_propTypes.default.object).isRequired,
  filters: _propTypes.default.object.isRequired,
  onChangeFilters: _propTypes.default.func.isRequired
};
var _default = exports.default = Filters;